export default __webpack_public_path__ + "assets/img/ict-pencil.5be5d671a1b46f0202665461db0e2b93.svg";